/* eslint-disable @typescript-eslint/no-explicit-any */
export enum ErrorSeverity {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  CRITICAL = "critical",
}

interface ErrorParams {
  message: string;
  code?: string;
  severity?: ErrorSeverity;
  context?: Record<string, any>;
  originalError?: any;
  componentStack?: string; // Add the missing componentStack property
}

export const trackError = ({
  message,
  code = "UNKNOWN",
  severity = ErrorSeverity.ERROR,
  context = {},
  originalError,
  componentStack, // Include it in the parameter destructuring
}: ErrorParams) => {
  // In development, log to console
  if (process.env.NODE_ENV === "development") {
    console.group(`[${severity.toUpperCase()}] ${code}: ${message}`);
    if (context && Object.keys(context).length > 0) {
      console.log("Context:", context);
    }
    if (originalError) {
      console.error("Original error:", originalError);
    }
    if (componentStack) {
      console.log("Component stack:", componentStack);
    }
    console.groupEnd();
  }

  // For production environments, send logs to backend
  if (process.env.NODE_ENV === "production") {
    try {
      fetch("/api/log", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          level: severity,
          message,
          code,
          context,
          error: originalError?.toString?.() || "Unknown error",
          componentStack,
          timestamp: new Date().toISOString(),
          url: typeof window !== "undefined" ? window.location.href : null,
        }),
      }).catch((e) => console.error("Failed to send error log:", e));
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // Silent catch - don't let error reporting cause more errors
    }
  }
};
